import ConfirmationModal from '../../components/confirmationModal';

namespace('IO.Views.NodeGroups', function (exports) {
  var PuppetModuleChanges = ConfirmationModal.extend({
    jstTemplate: 'node_groups/puppet_module_changes',

    setModuleChanges: function (name, addedModules, removedModules) {
      this._setupRender({
        ownerName: name,
        added: this._humanizedJoin(
          addedModules,
          '<span style="color: green;">',
          '</span>',
        ),
        removed: this._humanizedJoin(
          removedModules,
          '<span style="color: red;">',
          '</span>',
        ),
      });
    },

    _getTemplate: function (data, style) {
      return this.renderTemplate({
        moduleChanges: data,
        width: style.width,
        height: style.height,
      });
    },
  });

  exports.PuppetModuleChanges = PuppetModuleChanges;
});
